import React from "react";
import { BasicChequeredBoard, BasicChequeredBoardProps } from "../../components/BasicChequeredBoard/BasicChequeredBoard";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { GreyCard, GreyCardProps } from "../../components/GreyCard";
import { IconLinksCards } from "../../components/IconLinksCards";
import { Props as IconLinksCardProps } from "../../components/IconLinksCards/IconLinksCards";
import { Image, ImageProps } from "../../components/Image/Image";
import { LinkButton, LinkButtonProps } from "../../components/LinkButton";
import { Links, LinksProps } from "../../components/Links";
import { List } from "../../components/List";
import { OutagesCard, OutagesCardProps } from "../../components/OutagesCard";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { PricingTable, PricingTableProps } from "../../components/PricingTable";
import { ProcessSteps, ProcessStepsProps } from "../../components/ProcessSteps";
import { Responsibilities, ResponsibilitiesProps } from "../../components/Responsibilities";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { GenericListProps } from "../../types/GenericListType";

export interface ComponentTestPageProps {
  seo?: SeoHeaderProps;
  componentTestFaqs?: FaqAccordionGroupProps;
  chequeredBoard?: BasicChequeredBoardProps;
  componentTestProcess?: ProcessStepsProps;
  componentTestParagraph?: ParagraphProps;
  checkedList?: GenericListProps;
  circleList?: GenericListProps;
  customList?: GenericListProps;
  nestedList?: GenericListProps;
  titlelessList?: GenericListProps;
  componentTestLinkButton?: LinkButtonProps;
  componentLinksTitleAbove?: LinksProps;
  componentLinksTitleInside?: LinksProps;
  componentIconLinksCard?: IconLinksCardProps;
  pricingTable?: PricingTableProps;
  pricingTable2?: PricingTableProps;
  pricingTable3?: PricingTableProps;
  pricingTable4?: PricingTableProps;
  greyCard?: GreyCardProps;
  outagesCards?: OutagesCardProps;
  image?: ImageProps;
  responsibilities?: ResponsibilitiesProps;
}

export const ComponentTestPage: React.FC<ComponentTestPageProps> = ({
  seo,
  componentTestFaqs,
  chequeredBoard,
  componentTestProcess,
  checkedList,
  circleList,
  customList,
  nestedList,
  componentTestParagraph,
  componentTestLinkButton,
  componentLinksTitleInside,
  componentLinksTitleAbove,
  componentIconLinksCard,
  pricingTable,
  pricingTable2,
  pricingTable3,
  pricingTable4,
  greyCard,
  outagesCards,
  image,
  responsibilities,
}) => {
  return (
    <ServiceCataloguePageWrapper title="Component Test Page" seo={seo} faqs={componentTestFaqs}>
      {chequeredBoard && <BasicChequeredBoard {...chequeredBoard} />}
      {componentIconLinksCard && <IconLinksCards {...componentIconLinksCard} />}
      {componentTestParagraph && <Paragraph {...componentTestParagraph} />}
      {componentTestProcess && <ProcessSteps {...componentTestProcess} />}
      {componentTestLinkButton && <LinkButton {...componentTestLinkButton}>{componentTestLinkButton.children}</LinkButton>}
      {checkedList && <List {...checkedList} />}
      {circleList && <List {...circleList} />}
      {customList && <List {...customList} />}
      {nestedList && <List {...nestedList} />}
      {componentLinksTitleAbove && <Links {...componentLinksTitleAbove} my={4} />}
      {componentLinksTitleInside && <Links {...componentLinksTitleInside} my={4} />}
      {pricingTable && <PricingTable {...pricingTable} />}
      {pricingTable2 && <PricingTable {...pricingTable2} />}
      {pricingTable3 && <PricingTable {...pricingTable3} />}
      {pricingTable4 && <PricingTable {...pricingTable4} />}
      {greyCard && <GreyCard {...greyCard} />}
      {outagesCards && <OutagesCard {...outagesCards} />}
      {image && <Image {...image} title="some title" data-testid="image" />}
      {responsibilities && <Responsibilities {...responsibilities} />}
    </ServiceCataloguePageWrapper>
  );
};
